(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-equipment-sale-circle"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  function refresh() {
    pending = false;
    document.querySelectorAll('[data-ct-offer-percent]').forEach(el => {
      const section = el.closest('.shopify-section');
      const form = document.getElementById(el.dataset.ctOfferForm);
      const input = form?.querySelector('[name="id"]') ||
        section?.querySelector('form [name="id"]:not([disabled])');
      if (!input) return;
      let variants;
      try { variants = JSON.parse(el.dataset.ctOfferVariants); } catch { return; }
      const variant = variants.find(item => String(item.id) === String(input.value));
      if (!variant) return;
      const percent = Number(el.dataset.ctOfferPercent);
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: el.dataset.ctOfferCurrency || 'CAD',
        currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
      const sale = format(Math.round(variant.price * (100 - percent) / 100));
      const regular = format(variant.price);
      const actual = el.querySelector('[data-regular-price]');
      const compare = el.querySelector('[data-compare-price]');
      if (actual && actual.textContent.trim() !== sale) actual.textContent = sale;
      if (compare) {
        if (compare.textContent.trim() !== regular) compare.textContent = regular;
        if (compare.classList.contains('hidden')) compare.classList.remove('hidden');
      }
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(refresh);
  }
  function start() {
    document.querySelectorAll('[data-ct-offer-percent]').forEach(el => {
      new MutationObserver(schedule).observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    document.addEventListener('change', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
